import * as u from '../utils';

export default () => {
    const handleClick = (e) => {
        if (
            u.hasClass(e.target, 'woocommerce-notices-wrapper__close') ||
            u.hasClass(e.target.parentNode, 'woocommerce-notices-wrapper__close')
        ) {
            const notice = u.closestByClass(e.target, 'woocommerce-notices-wrapper__notice');

            slideUp(notice).then(function () {
                notice.remove();
            });
        }
    };

    document.addEventListener('click', handleClick);
};
